export default "__VITE_ASSET__07D_1B8O__"